// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.labelTitulo[data-v-3add3ef2] {
    text-align: left;
    margin-left: -5px;
}
.wrap-text[data-v-3add3ef2] {
    -webkit-line-clamp: unset !important;
}
.v-stepper[data-v-3add3ef2] {
    top: 0;
    width: 100%;
    background-color: rgba(255, 255, 255, 1);
}
.container[data-v-3add3ef2] {
    max-width: 100%;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
